import React, { FC, useCallback, useRef } from 'react'
import { FaChevronDown } from 'react-icons/fa6'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

import styles from './index.module.css'

type Props = {
  type: string
}

export const TermsSelector: FC<Props> = ({ type }) => {
  const ref = useRef(null)
  const router = useRouter()
  const { t } = useTranslation()

  const handleChangeTermType = useCallback(
    (type: string) => {
      if (type === 'locker') {
        router.push('/terms/user/locker')
      }

      if (type === 'space') {
        router.push('/terms/user/space')
      }

      if (type === 'owner') {
        router.push('/terms/owner')
      }
    },
    [router]
  )

  return (
    <div
      onClick={() => {
        try {
          ref.current?.showPicker()
        } catch (error) {
          ref.current?.focus()
        }
      }}
      className={styles.container}
    >
      <div style={{ position: 'absolute', inset: 0 }}>
        <select
          ref={ref}
          className={styles.selector}
          value={type}
          onChange={(e) => handleChangeTermType(e.target.value)}
        >
          <option value="space">{t('LEGAL.TERMS.OPTIONS.SPACE')}</option>
          <option value="locker">{t('LEGAL.TERMS.OPTIONS.LOCKER')}</option>
          <option value="owner">{t('LEGAL.TERMS.OPTIONS.OWNER')}</option>
        </select>
      </div>
      <FaChevronDown size={16} color="#333" />
    </div>
  )
}
